import styled from "styled-components";
import { ColorTheme } from "../../../../styling/theme"

export const TextDivider = styled.p`
    width: 100%;
    margin: 15px 0px;
    text-align: center;
    text-transform: uppercase;
    color: ${ColorTheme.font.gray};
`